var render = function render(){var _vm=this,_c=_vm._self._c;return _c('printer-image',{attrs:{"printer-type-id":_vm.printer.printerTypeId}})
}
var staticRenderFns = []

export { render, staticRenderFns }